import { useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "@/lib/api";
import AuthLayout, { inputStyle, labelStyle, errorStyle } from "@/components/AuthLayout";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null); // { message, reset_link? }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      const data = await apiFetch("/auth/forgot-password", {
        method: "POST",
        body: { email: email.trim().toLowerCase() },
      });
      setResult(data);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (result) {
    return (
      <AuthLayout
        title="Check your email"
        subtitle={result.message}
        footer={
          <Link to="/login" style={{ fontSize: "0.85rem", color: "#D4AF37" }}>
            Back to login
          </Link>
        }
      >
        {/* Only present when the backend is running with ENVIRONMENT=test —
            lets you test the reset flow before any email workflow exists. */}
        {result.reset_link && (
          <div
            style={{
              padding: "1rem",
              borderRadius: 10,
              background: "rgba(212, 175, 55, 0.08)",
              border: "1px solid rgba(212, 175, 55, 0.25)",
              fontSize: "0.85rem",
              wordBreak: "break-all",
            }}
            data-testid="test-mode-reset-link"
          >
            <strong style={{ color: "#D4AF37" }}>Test mode:</strong>{" "}
            <a href={result.reset_link} style={{ color: "#F4F6F0" }}>
              {result.reset_link}
            </a>
          </div>
        )}
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter the email you paid with — we'll send a link to set a new password."
      footer={
        <Link to="/login" style={{ fontSize: "0.85rem", color: "#A0A0B0" }}>
          Back to login
        </Link>
      }
    >
      <form onSubmit={handleSubmit} data-testid="forgot-password-form">
        <div style={{ marginBottom: "1.1rem" }}>
          <label style={labelStyle} htmlFor="fp-email">Email</label>
          <input
            id="fp-email"
            data-testid="forgot-password-email-input"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
        </div>

        {error && <p style={errorStyle}>{error}</p>}

        <button
          type="submit"
          data-testid="forgot-password-submit"
          disabled={loading}
          className="cta-button"
          style={{ width: "100%", justifyContent: "center", opacity: loading ? 0.7 : 1, marginTop: "0.5rem" }}
        >
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
